/**
 * Parses the gutenberghub query id from the query loop instance.
 *
 * @param {HTMLDivElement|null} queryLoopInstance - Query loop instance.
 * @return {number} - Query id if found, otherwise -1.
 */
export function ctbParseQueryId(queryLoopInstance) {
	if (!queryLoopInstance) {
		return -1;
	}

	const classList = Array.from(queryLoopInstance.classList);
	const queryClass = classList.find((className) =>
		className.startsWith('ghub-query-id-')
	);

	if (!queryClass) {
		return -1;
	}

	const classTokens = queryClass.split('-');

	return Number(classTokens[classTokens.length - 1]);
}
